import { render, staticRenderFns } from "./StudyInformation.vue?vue&type=template&id=4792939d&"
import script from "./StudyInformation.vue?vue&type=script&lang=js&"
export * from "./StudyInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports